import React from 'react';
import { Table } from 'react-bootstrap';
import { PREDICATE } from "../../constants";

function renderFunctionValueSelect(functionName, functionValues, params, domain, onChange, disabled) {
  let value = functionValues[JSON.stringify(params)];

  if (!value) {
    value = '';
  }

  return /*#__PURE__*/React.createElement("select", {
    onChange: e => onChange(params.concat([e.target.value]), functionName),
    value: value
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, ''), domain.map(item => /*#__PURE__*/React.createElement("option", {
    key: item,
    disabled: disabled,
    value: item
  }, item)));
}

export function RelationalTable(props) {
  let domain = [...props.domain];

  let inputComponent = item => /*#__PURE__*/React.createElement("td", {
    key: item,
    className: "checkComponent"
  }, props.type === PREDICATE ? /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onChange: e => props.onInputChange(item, props.name, e.target.checked),
    checked: props.value.findIndex(e => JSON.stringify(e) === JSON.stringify(item)) > -1,
    disabled: props.disabled
  }) : renderFunctionValueSelect(props.name, props.value, item, domain, props.onInputChange, props.disabled));

  let arity1 = /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, ''), domain.map(item => inputComponent([item])));
  let arity2 = domain.map(item1 => /*#__PURE__*/React.createElement("tr", {
    key: item1
  }, /*#__PURE__*/React.createElement("th", {
    className: "interpretationHead"
  }, item1), domain.map(item2 => inputComponent([item1, item2]))));
  return /*#__PURE__*/React.createElement(Table, {
    bordered: true,
    responsive: true,
    size: "sm",
    className: "small"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    className: "interpretationHead"
  }, props.name), domain.map(item => /*#__PURE__*/React.createElement("th", {
    key: item,
    className: "interpretationHead"
  }, item)))), /*#__PURE__*/React.createElement("tbody", null, parseInt(props.arity) === 1 ? arity1 : arity2));
}